import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Link } from "react-router";
import { ListFilter } from "lucide-react";
import { SALES_GATEWAYS, SalesGateway } from "./SaleRecord.ts";
import { SALES_GATEWAY_LABELS } from "./salesLabels.ts";
import { formatCount } from "./salesFormat.ts";

export type OrdersListLink = {
  gateway: SalesGateway;
  orderCount: number;
  path: string;
};

export function OrdersLinksMenu({
  label,
  links,
}: {
  label: string;
  links: OrdersListLink[];
}) {
  const linksByGateway = SALES_GATEWAYS.flatMap(
    (gateway) => links.find((link) => link.gateway === gateway) ?? [],
  ).filter((link) => link.orderCount > 0);
  if (linksByGateway.length === 0) return null;

  return (
    <Menu>
      <MenuButton
        title={label}
        aria-label={label}
        className="shrink-0 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700 data-[open]:bg-slate-100"
      >
        <ListFilter className="w-3.5 h-3.5" />
      </MenuButton>
      <MenuItems
        anchor="bottom start"
        transition
        className="z-50 min-w-48 rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black/5 [--anchor-gap:4px] transition duration-100 ease-out focus:outline-none data-[closed]:opacity-0"
      >
        <p className="px-3 py-1 text-xs text-gray-400">{label}</p>
        {linksByGateway.map((link) => (
          <MenuItem key={link.gateway}>
            <Link
              to={link.path}
              className="flex items-center justify-between gap-4 px-3 py-1.5 text-gray-700 data-[focus]:bg-gray-50"
            >
              <span>{SALES_GATEWAY_LABELS[link.gateway]}</span>
              <span className="text-xs text-gray-400">
                {formatCount(link.orderCount)}{" "}
                {link.orderCount === 1 ? "ordine" : "ordini"}
              </span>
            </Link>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}
